import { render } from "./signlog.vue?vue&type=template&id=f87a2756"
import script from "./signlog.vue?vue&type=script&lang=js"
export * from "./signlog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__